/* Charger product page: "Will it work with my car?" (sections/zvp-carfit.liquid).
   Typed car search with suggestions, same matching as the home page finder
   (assets/zvh-finder.js): token by token, typo-tolerant, "c3" finds "eC3".
   Picking a car shows the speed THIS charger gives it, range per hour,
   full-charge time, what limits it and one line of advice (a sister
   product when one fits better). Speed rules:
   - a single-phase car on a three-phase charger takes one phase:
     11 kW unit -> 3.6 kW, 22 kW unit -> 7.5 kW
   - otherwise the lower of what the car accepts and what the charger gives.
   ?ev=<car-slug> in the address pre-picks a car (links from sister pages). */
(function () {
  var FEED = 'https://widget.zevpoint.com/api/public/plan/cars';
  var ONE_PHASE = { 11: 3.6, 22: 7.5 };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function slugify(n) { return n.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function speed(ch, car) {
    var out = parseFloat(ch.kw);
    if (ch.phase === 'three' && car.o < 11) out = ONE_PHASE[out] || Math.round(out / 3 * 10) / 10;
    return Math.round(Math.min(car.o, out) * 10) / 10;
  }

  /* ---- matching (from zvh-finder.js) ---- */
  function normText(s) {
    s = (s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function squash(s) { return normText(s).replace(/ /g, ''); }
  function dedupe(s) { return s.replace(/(.)\1+/g, function (run, ch) { return run.length === 2 ? ch : run; }); }
  function editDist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur[0] = i;
      var best = cur[0];
      for (j = 1; j <= b.length; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      for (j = 0; j <= b.length; j++) prev[j] = cur[j];
    }
    return prev[b.length];
  }
  function slack(n) { return n >= 6 ? 2 : (n >= 4 ? 1 : 0); }
  function carTokens(c) {
    if (c._t) return c._t;
    var toks = normText(c.n).split(' '), extra = [];
    toks.forEach(function (w) { if (w.length >= 3 && w.length <= 5 && w.charAt(0) === 'e') extra.push(w.slice(1)); });
    c._t = { toks: toks.concat(extra).filter(Boolean), sq: squash(c.n), nsq: squash(c.n) };
    return c._t;
  }
  function tokenScore(c, t) {
    var d = carTokens(c), toks = d.toks, i, w, td = dedupe(t);
    for (i = 0; i < toks.length; i++) {
      w = toks[i];
      if (w === t || w === td) return 100;
      if (w.indexOf(t) === 0 || w.indexOf(td) === 0) return 80;
    }
    if (t.length >= 3) {
      if (d.sq.indexOf(t) === 0) return 70;
      if (d.sq.indexOf(t) !== -1) return 50;
    }
    var s = slack(t.length);
    if (s > 0) {
      for (i = 0; i < toks.length; i++) {
        w = toks[i];
        if (w.charAt(0) !== t.charAt(0)) continue;
        if (w.length > t.length && editDist(t, w.slice(0, t.length), s) <= s) return 60;
      }
      for (i = 0; i < toks.length; i++) {
        w = toks[i];
        if (w.charAt(0) !== t.charAt(0)) continue;
        if (editDist(t, w, s) <= s) return 30;
      }
    }
    return 0;
  }

  function init(root) {
    if (root.__zvpF2) return;
    root.__zvpF2 = 1;
    var me;
    try { me = JSON.parse(root.querySelector('[data-fit]').textContent); } catch (e) { return; }
    function q(s) { return root.querySelector(s); }
    var input = q('.zvp-fit__input'), panel = q('.zvp-fit__panel'), search = q('.zvp-fit__search');
    var picked = q('.zvp-fit__picked'), out = q('.zvp-fit__out'), hint = q('[data-static]');
    if (!input || !panel) return;
    var WA = root.getAttribute('data-wa') || 'https://wa.me/919779750538';
    var cars = [], list = [], act = 0, closeTimer = null;

    function matches(text) {
      var raw = normText(text);
      if (!raw) return cars.filter(function (c) { return c.p; }).slice(0, 6);
      var qt = raw.split(' '), sqq = raw.replace(/ /g, ''), scored = [];
      cars.forEach(function (c) {
        var total = 0, missed = 0, strong = 0, exact = 0, i, t, s;
        for (i = 0; i < qt.length; i++) {
          t = qt[i];
          s = tokenScore(c, t);
          if (s) { total += s; if (t.length >= 3) strong++; if (s === 100) exact++; continue; }
          if (/^[0-9]+$/.test(t) || t.length <= 2) { missed++; continue; }
          missed = 999;
          break;
        }
        if (missed >= 999 || total === 0) return;
        if (strong === 0 && exact === 0) return;
        var nsq = carTokens(c).nsq;
        if (nsq.indexOf(sqq) === 0) total += 200;
        else if (nsq.indexOf(sqq) !== -1) total += 120;
        if (c.p) total += 15;
        total -= missed * 5;
        total -= c.n.length * 0.1;
        scored.push({ c: c, s: total });
      });
      scored.sort(function (a, b) { return b.s - a.s || a.c.n.localeCompare(b.c.n); });
      return scored.slice(0, 7).map(function (r) { return r.c; });
    }
    function highlight(name, text) {
      text = (text || '').trim().toLowerCase();
      if (!text) return esc(name);
      var low = name.toLowerCase(), i = low.indexOf(text), len = text.length;
      if (i < 0) { var t = text.split(/\s+/)[0]; i = low.indexOf(t); len = t.length; }
      if (i < 0 || !len) return esc(name);
      return esc(name.slice(0, i)) + '<mark>' + esc(name.slice(i, i + len)) + '</mark>' + esc(name.slice(i + len));
    }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function render() {
      var text = input.value, has = !!text.trim();
      list = matches(text);
      if (!has && !list.length) { close(); return; }
      act = Math.min(act, Math.max(0, list.length - 1));
      var html = has ? '' : '<div class="zvp-fit__cap">Popular in India</div>';
      list.forEach(function (c, i) {
        html += '<button type="button" class="zvp-fit__opt' + (i === act ? ' is-on' : '') + '" role="option" data-i="' + i + '">'
          + '<b>' + highlight(c.n, text) + '</b><small>' + (c.b ? esc(c.b) + ' kWh battery \u00b7 ' : '') + esc(c.o) + ' kW AC</small></button>';
      });
      if (has && !list.length) {
        html += '<div class="zvp-fit__none">No match for \u201c' + esc(text.trim()) + '\u201d. <a href="' + esc(WA) + '" class="zv-wa-sales" target="_blank" rel="noopener">Ask us on WhatsApp \u2192</a></div>';
      }
      panel.innerHTML = html;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function setActive(i) {
      act = Math.max(0, Math.min(list.length - 1, i));
      Array.prototype.forEach.call(panel.querySelectorAll('.zvp-fit__opt'), function (r, k) { r.classList.toggle('is-on', k === act); });
    }

    function show(car) {
      var kw = speed(me, car);
      q('[data-speed]').textContent = kw + ' kW';
      q('[data-range]').textContent = car.b && car.r ? '\u2248 ' + Math.round(kw * car.r / car.b) + ' km' : '\u2014';
      q('[data-hours]').textContent = car.b ? '\u2248 ' + (Math.round(car.b / kw * 10) / 10) + ' h' : '\u2014';
      var byCar = kw >= car.o - 0.05;
      q('[data-limit]').textContent = byCar ? 'Your car\u2019s onboard charger' : (me.phase === 'three' && car.o < 11 ? 'One phase of this charger' : 'This charger');
      var advice = q('[data-advice]');
      advice.textContent = '';
      var sis = me.sisters || [];
      var faster = sis.filter(function (s) { return speed(s, car) > kw + 0.05; }).sort(function (a, b) { return speed(b, car) - speed(a, car) || a.price - b.price; })[0];
      var cheaper = sis.filter(function (s) { return speed(s, car) >= kw - 0.05 && s.price < me.price; }).sort(function (a, b) { return a.price - b.price; })[0];
      var lead = car.n + ' accepts up to ' + car.o + ' kW AC. ';
      var pick = null, text;
      if (faster) { pick = faster; text = lead + me.name + ' gives it ' + kw + ' kW; ' + faster.name + ' gives it ' + speed(faster, car) + ' kW. '; }
      else if (cheaper) { pick = cheaper; text = lead + 'A bigger charger won\u2019t make it faster \u2014 ' + cheaper.name + ' charges it at the same ' + kw + ' kW for less. '; }
      else text = lead + me.name + ' is the right fit.' + (me.phase === 'three' ? ' It needs a three-phase connection.' : '');
      advice.appendChild(document.createTextNode(text));
      if (pick) {
        var a = document.createElement('a');
        a.href = pick.url + '?ev=' + slugify(car.n);
        a.textContent = 'See ' + pick.name + ' \u2192';
        advice.appendChild(a);
      }
      out.hidden = false;
      if (hint) hint.hidden = true;
    }
    function choose(car) {
      clearTimeout(closeTimer);
      close();
      input.value = '';
      input.blur();
      search.hidden = true;
      picked.hidden = false;
      q('[data-car]').textContent = car.n;
      q('[data-carmeta]').textContent = (car.b ? car.b + ' kWh battery \u00b7 ' : '') + 'up to ' + car.o + ' kW AC';
      show(car);
    }
    function reset() {
      picked.hidden = true;
      search.hidden = false;
      out.hidden = true;
      if (hint) hint.hidden = false;
      act = 0;
      input.focus();
    }

    input.addEventListener('focus', function () { clearTimeout(closeTimer); render(); });
    input.addEventListener('input', function () { act = 0; render(); });
    input.addEventListener('blur', function () { closeTimer = setTimeout(close, 180); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden) render(); else setActive(act + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(act - 1); }
      else if (e.key === 'Enter') { e.preventDefault(); if (!panel.hidden && list[act]) choose(list[act]); }
      else if (e.key === 'Escape') { close(); input.blur(); }
    });
    panel.addEventListener('mousedown', function (e) { if (!e.target.closest('a')) e.preventDefault(); });
    panel.addEventListener('mousemove', function (e) {
      var row = e.target.closest && e.target.closest('.zvp-fit__opt');
      if (row) { var i = +row.getAttribute('data-i'); if (i !== act) setActive(i); }
    });
    panel.addEventListener('click', function (e) {
      var row = e.target.closest && e.target.closest('.zvp-fit__opt');
      if (row && list[+row.getAttribute('data-i')]) choose(list[+row.getAttribute('data-i')]);
    });
    var change = q('[data-change]');
    if (change) change.addEventListener('click', reset);

    fetch(FEED).then(function (r) { return r.json(); }).then(function (d) {
      var feed = Array.isArray(d) ? d : (d.cars || []);
      cars = feed.map(function (c) {
        return { n: (c.brand + ' ' + c.model).trim(), o: +c.onboard_charger_kw || 7.5, b: +c.battery_kwh || 0, r: +c.range_km || 0, p: !!c.popular };
      }).sort(function (a, b) { return a.n.localeCompare(b.n); });
      if (document.activeElement === input) render();
      var slug = null;
      try { slug = new URLSearchParams(window.location.search).get('ev'); } catch (e) {}
      var pre = slug && cars.filter(function (c) { return slugify(c.n) === slug; })[0];
      if (pre) choose(pre);
    }).catch(function () { search.hidden = true; });
  }

  function mount(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-zvp-fit2]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(); });
  else mount();
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();
